import React, { useEffect, useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import Select from 'react-select';
import * as yup from 'yup';
import { Link, Redirect } from 'react-router-dom';
import { Navbar } from '../../../components/Navbar';
import { Sidebar } from '../../../components/Sidebar';

import { LogOutModal } from '../../../components/LogOutModal';

import 'moment/locale/pt-br';
import api from '../../../config/configApi';
import { isPermissoesAdmin } from '../../../utils/acl/permissoes';

export function EditUser(props) {
  const moment = require('moment');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [empresaId, setEmpresaId] = useState('');
  const [equipeId, setEquipeId] = useState('');
  const [perfilId, setPerfilId] = useState('');
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [outraId, setOutraId] = useState('');
  const [matricula, setMatricula] = useState('');
  const [celular, setCelular] = useState('');
  const [cep, setCep] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [datanascimento, setDataNascimento] = useState('');
  const [isActive, setIsActive] = useState(null);
  const [id] = useState(props.match.params.id);
  const [selectedSetores, setSelectedSetores] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [unidadeId, setUnidadeId] = useState('');
  const [unidades, setUnidades] = useState([]);
  const [tempStatus, setTempStatus] = useState(isActive);
  const [setoresOptions, setSetoresOptions] = useState([]);
  // ✅ Novo estado para o alerta flutuante
  const [floatAlertSuccess, setFloatAlertSuccess] = useState({
    isVisible: false,
    message: '',
  });

  // ✅ Fecha automaticamente o alerta após 4 segundos
  useEffect(() => {
    if (floatAlertSuccess.isVisible) {
      const timer = setTimeout(() => {
        setFloatAlertSuccess({ isVisible: false, message: '' });
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [floatAlertSuccess.isVisible]);
  const getSetores = async () => {
    try {
      const { data } = await api.get('/setores');

      const formattedSetores = data.map((setor) => ({
        value: setor.id,
        label: setor.nome,
      }));

      setSetoresOptions(formattedSetores);
    } catch (err) {
      console.error('Erro ao carregar setores:', err);
    }
  };

  useEffect(() => {
    getSetores();
  }, []);

  const handleStatusChange = (status) => {
    if (status === 'Inativo') {
      setTempStatus(false);
      setShowModal(true);
    } else {
      setIsActive(true);
    }
  };

  const confirmStatusChange = () => {
    setIsActive(tempStatus);
    setShowModal(false);
  };

  const [status, setStatus] = useState({
    type: '',
    mensagem: '',
  });

  // 🟩 Função que atualiza o usuário
  const editUser = async (e) => {
    e.preventDefault();

    const headers = { headers: { 'Content-Type': 'application/json' } };
    const departmentIds = selectedSetores.map((option) => option.value).join(', ') || '';

    try {
      const response = await api.put(
        '/user/user',
        {
          id,
          nome,
          email,
          celular,
          empresaId,
          equipeId,
          perfilId,
          // Backend só aceita essa troca se quem está logado já é super-admin
          // (ver controller/user.js) - enviar sempre é inofensivo, o backend
          // ignora o campo silenciosamente quando o chamador não tem o selo.
          isSuperAdmin,
          outraId,
          matricula,
          cep,
          logradouro,
          numero,
          complemento,
          bairro,
          cidade,
          datanascimento,
          departmentIds,
          isActive,
          unidadeId: +unidadeId,
        },
        headers,
      );

      // ✅ Mostra mensagem de sucesso
      setStatus({
        type: 'success',
        mensagem: response?.data?.mensagem || 'Dados salvos com sucesso!',
      });

      // ✅ Atualiza o alerta flutuante, se quiser usar
      setFloatAlertSuccess({
        isVisible: true,
        message: response?.data?.mensagem || 'Dados salvos com sucesso!',
      });

      // ✅ Recarrega os dados do usuário após salvar
      await getUser();
    } catch (err) {
      // ⚠️ Tratar erro corretamente
      const mensagemErro = err?.response?.data?.mensagem || 'Erro: Tente mais tarde!';
      setStatus({
        type: 'error',
        mensagem: mensagemErro,
      });
    }
  };

  // 🟩 Função que busca os dados do usuário
  const getUser = async () => {
    const headers = {
      headers: { 'Content-Type': 'application/json' },
    };

    try {
      const response = await api.get(`/user/user/${id}`, headers);
      const user = response.data?.user;

      if (!user) {
        setStatus({
          type: 'redWarning',
          mensagem: 'Erro: Usuário não encontrado!',
        });
        return;
      }

      // ✅ Preenche os campos com os dados vindos da API
      setNome(user.nome);
      setEmail(user.email);
      setEmpresaId(user.empresaId);
      setEquipeId(user.equipeId);
      setPerfilId(user.perfilId);
      setIsSuperAdmin(!!user.isSuperAdmin);
      setCelular(user.celular);
      setOutraId(user.outraId);
      setMatricula(user.matricula);
      setCep(user.cep);
      setLogradouro(user.logradouro);
      setNumero(user.numero);
      setComplemento(user.complemento);
      setBairro(user.bairro);
      setCidade(user.cidade);
      setDataNascimento(user.datanascimento);
      setUnidadeId(user.unidadeId);
      setIsActive(user.isActive);

      // ✅ Preenche os setores do usuário
      if (user.departments?.length) {
        const userStores = user.departments.map((s) => ({
          value: s.id,
          label: s.nome,
        }));
        setSelectedSetores(userStores);
      }
    } catch (err) {
      const mensagemErro = err?.response?.data?.mensagem || 'Erro: Tente mais tarde!';
      setStatus({
        type: 'error',
        mensagem: mensagemErro,
      });
    }
  };

  // 🟩 Executa getUser assim que a tela abrir ou mudar o ID
  useEffect(() => {
    getUser();
  }, [id]);

  async function validate() {
    const schema = yup.object().shape({
      email: yup.string('Erro: Necessário preencher o campo e-mail!')
        .email('Erro: Necessário preencher o campo e-mail!')
        .required('Erro: Necessário preencher o campo e-mail!'),
      nome: yup.string('Erro: Necessário preencher o campo nome!')
        .required('Erro: Necessário preencher o campo nome!'),
    });

    try {
      await schema.validate({ nome, email });
      return true;
    } catch (err) {
      setStatus({ type: 'error', mensagem: err.errors });
      return false;
    }
  }

  const getUnidades = async () => {
    try {
      const { data } = await api.get('/unidade/unidades');
      setUnidades(data.unidades);
    } catch (error) {
      setStatus({
        type: 'error',
        mensagem: 'Não foi possível carregar as unidades',
      });
    }
  };

  useEffect(() => {
    getUnidades();
  }, []);

  return (
    <>
      {/* ✅ Alerta flutuante de sucesso */}
      {floatAlertSuccess.isVisible && (
        <div
          style={{
            position: 'fixed',
            top: 20,
            right: 20,
            zIndex: 1050,
            width: '300px',
          }}
        >
          <div className="alert alert-success alert-dismissible fade show" role="alert">
            <strong>{floatAlertSuccess.message}</strong>
            <button
              type="button"
              className="btn-close"
              onClick={() => setFloatAlertSuccess({ isVisible: false, message: '' })}
            />
          </div>
        </div>
      )}
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">

                  <div className="alert-content-adm">
                    {status.type === 'redWarning'
                      ? (
                        <Redirect to={{
                          pathname: '/users',
                          state: {
                            type: 'error',
                            mensagem: status.mensagem,
                          },
                        }}
                        />
                      ) : ''}
                    {status.type === 'redSuccess' ? (
                      <Redirect to={{
                        pathname: '/users',
                        state: {
                          type: 'success',
                          mensagem: status.mensagem,
                        },
                      }}
                      />
                    ) : ''}
                    {status.type === 'error' ? <p className="alert-danger">{status.mensagem}</p> : ''}
                  </div>
                  <div className="row">
                    <div className="col-xl-8 col-md-6 mb-4">
                      <h6 className="m-0 font-weight-bold text-primary">
                        Editar Usuário:
                        {nome}
                      </h6>
                    </div>

                    <div className="col-xl-2 col-md-6 mb-4">

                      <Link to="/users"><button type="button" className="btn btn-info btn-block">Listar</button></Link>
                      {' '}

                    </div>
                    <div className="col-xl-2 col-md-6 mb-4">
                      <Link to={`/view-user/${id}`}>
                        {' '}
                        <button type="button" className="btn btn-primary  btn-block">Visualizar</button>
                        {' '}
                      </Link>
                      {' '}

                    </div>

                  </div>

                </div>

                <div className="card-body">
                  <form onSubmit={editUser} className="form-adm">

                    <div className="form-row">

                      <div className="form-group col-md-4">
                        <label htmlFor="inputPassword4">Nome</label>
                        <input type="text" name="nome" id="nome" className="form-control" placeholder="Nome completo do usuário" value={nome} onChange={(text) => setNome(text.target.value)} />
                      </div>

                      <Form.Group className="col-lg-2 col-md-6">
                        <Form.Label>Unidade</Form.Label>
                        <Form.Select
                          aria-label="Selecione uma unidade"
                          name="unidade"
                          value={unidadeId}
                          onChange={(e) => setUnidadeId(e.target.value || '')}
                          required
                        >
                          <option value="">Selecione uma Unidade</option>
                          {unidades.map((unidade) => (
                            <option key={unidade.id} value={unidade.id}>
                              {unidade.nome}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>

                      <div className="form-group col-md-4">
                        <label htmlFor="inputEmail4">Email</label>
                        <input type="email" name="email" id="email" className="form-control" placeholder="Melhor e-mail do usuário" value={email} onChange={(text) => setEmail(text.target.value)} />
                      </div>

                      <div className="form-group col-md-2">
                        <label htmlFor="inputPassword4">Nascimento</label>
                        <input type="text" name="datanascimento" id="datanascimento" className="form-control" autoComplete="on" value={datanascimento} onChange={(text) => setDataNascimento(text.target.value)} />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-2">
                        <label htmlFor="inputEmail4">Empresa</label>

                        <select className="custom-select my-1 mr-sm-2" name="empresaId" id="empresaId" placeholder="Empresa Usuário" value={empresaId} onChange={(text) => setEmpresaId(text.target.value)}>
                          <option value="">Selecione o Empresa</option>
                          <option value="1">Marcelo Manhaes</option>
                        </select>
                      </div>

                      <div className="form-group col-md-2">
                        <label htmlFor="inputEmail4">Outra</label>
                        <select className="custom-select my-1 mr-sm-2" name="empresaId" id="outraId" placeholder="Outra Usuário" value={outraId} onChange={(text) => setOutraId(text.target.value)}>
                          <option value="">Selecione o Outra</option>
                          <option value="1">Outra</option>
                        </select>

                      </div>

                      <div className="form-group col-md-2">
                        <label htmlFor="inputEmail4">Perfil</label>
                        <select className="custom-select my-1 mr-sm-2" name="perfilId" id="perfilId" placeholder="Perfil Usuário" value={perfilId} onChange={(text) => setPerfilId(text.target.value)}>
                          <option value="">Selecione o Perfil</option>
                          <option value="1">Operador</option>
                          <option value="99">Administrador</option>

                        </select>
                        <Form.Text className="text-muted">
                          Esse campo é só um rótulo - não concede acesso nenhum
                          por si só. Acesso de verdade depende do checkbox
                          &quot;Super Admin&quot; (quando visível) e das
                          permissões concedidas em /admin/permissoes.
                        </Form.Text>

                      </div>

                      {isPermissoesAdmin() && (
                        <div className="form-group col-md-2">
                          <label htmlFor="isSuperAdminCheck">Super Admin</label>
                          <div className="custom-control custom-checkbox" style={{ marginTop: '4px' }}>
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="isSuperAdminCheck"
                              checked={isSuperAdmin}
                              onChange={(e) => setIsSuperAdmin(e.target.checked)}
                            />
                            <label className="custom-control-label" htmlFor="isSuperAdminCheck">
                              Ignora todas as permissões
                            </label>
                          </div>
                        </div>
                      )}

                      <div className="form-group col-md-2">
                        <label htmlFor="statusUsuario">Status</label>
                        <select className="custom-select" value={isActive ? 'Ativo' : 'Inativo'} onChange={(e) => handleStatusChange(e.target.value)} style={{ marginTop: '4px', height: '39px' }}>
                          <option value="Ativo">Ativo</option>
                          <option value="Inativo">Inativo</option>
                        </select>
                      </div>
                      <Modal show={showModal} onHide={() => setShowModal(false)}>
                        <Modal.Header closeButton>
                          <Modal.Title>Confirmação</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Tem certeza que deseja inativar este usuário?</Modal.Body>
                        <Modal.Footer>
                          <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                          <button className="btn btn-danger" onClick={confirmStatusChange}>Inativar</button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label htmlFor="setoresSelect"> Setores</label>
                        <Select
                          id="setoresSelect"
                          isMulti
                          options={setoresOptions}
                          value={selectedSetores}
                          onChange={setSelectedSetores}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </div>

                    </div>

                    <div className="form-group row">

                      <button type="submit" className="btn btn-success  btn-block">Salvar</button>
                    </div>

                  </form>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <LogOutModal />
    </>
  );
}
